app = angular.module("seismology")

app.controller "DashboardCtrl", ($scope, $window, $state, $translate, currentAuth, $firebaseAuth, $mdDialog, Users, CurrentUser, DesktopNotification) ->
  $scope.authData = currentAuth
  $scope.currentUser = CurrentUser.get()

  $translate.onReady ->
    $scope.lang = $translate.use()

  $scope.switchLang = (lang) ->
    $translate.use(lang).then ->
      $scope.lang = $translate.use()
    
  $scope.currentUser.$loaded ->
    $scope.editingListSize = Object.keys($scope.currentUser.editing or {}).length
    $scope.favListSize = Object.keys($scope.currentUser.favs or {}).length

  $scope.openSupportDialog = ->
    $mdDialog.show
      controller: ($scope) ->
        $scope.cancel = -> $mdDialog.hide()
      templateUrl: 'templates/dialogs/support.html'
      parent: angular.element(document.body)
      clickOutsideToClose: true

  $scope.openMLDialog = ->
    $mdDialog.show
      controller: ($scope) ->
        $scope.cancel = -> $mdDialog.hide()
      templateUrl: 'templates/dialogs/mailing-list.html'
      parent: angular.element(document.body)
      clickOutsideToClose: true

  $scope.openLinksDialog = ->
    $mdDialog.show
      controller: ($scope) ->
        $scope.cancel = -> $mdDialog.hide()
      templateUrl: 'templates/dialogs/links.html'
      parent: angular.element(document.body)
      clickOutsideToClose: true
  if DesktopNotification.checkNotificationSupport() 
    DesktopNotification.enableNotification()

    

app.controller "HomeCtrl", ($scope, $window, $location, $translate, Books, Timeline, Users, DailyStats) ->
  $scope.timeline = Timeline.getList(50)
  $scope.currentPath = $location.path()
  $scope.Books = Books
  $scope.charRanking = Users.getCharRanking(100)
  $scope.moment = $window.moment
  $scope.dispOptions =
    showOnlyRequestReview: false
    showWithComment: false
  $scope.isVisible = (event)->
    result = false
    if $scope.dispOptions.showOnlyRequestReview
      result = event.requestReview
    else if $scope.dispOptions.showWithComment
      result ||= event.comment and event.comment.length > 0
    else
      result = true
    result

  $scope.Users = Users
  DailyStats.getRecent(2).$loaded (stat)->
    today = stat[1]
    yesterday = stat[0]
    $scope.progress =
      charCount: today.char_count
      charCountIncrease: today.char_count - yesterday.char_count
      completedBooks: today.completed_books
      completedBooksIncrease: today.completed_books - yesterday.completed_books
      progressSum: today.progress_sum
      progressRatio: Math.floor((today.progress_sum/today.content_sum)*100)
      progressSumIncrease: today.progress_sum - yesterday.progress_sum
      contentSum: today.content_sum
      userCount: today.user_count-783
      bookCount: today.book_count

app.controller "ForumCtrl", ($scope, $window, $state, Users, Discussion, DiscussionFactory, DiscussionCategories) ->
  $scope.Users = Users
  $scope.moment = $window.moment
  $scope.showForm = false
  $scope.categories = DiscussionCategories
  $scope.toggleForm = ->
    $scope.newDiscussion = 
      title: ''
      text: ''
      category: 'question'
      commentCount: 0
      images: []    
    $scope.showForm = !$scope.showForm
    $scope.imagesToUpload = []
    $scope.disableSubmit = false
  $scope.selectFiles = (files) ->
    for file in files
      if $scope.imagesToUpload.length >= 4
        return alert '添付できる写真は4枚までです。'      
      $scope.imagesToUpload.push(file)

  $scope.removeImage = (index) ->
    $scope.imagesToUpload.splice(index, 1)

  $scope.submit = ->
    $scope.disableSubmit = true
    DiscussionFactory.add($scope.newDiscussion, $scope.imagesToUpload).then ->
      $scope.toggleForm()

  $scope.switchNavItem = (name) ->
    $scope.selectedNavItem = name
    switch name
      when 'update'
        $scope.discussions = DiscussionFactory.getUpdated()
      when 'popular'
        $scope.discussions = DiscussionFactory.getPopular()
      else
        $scope.discussions = DiscussionFactory.getLatest()
    $scope.discussions.$ref().scroll.next(100)
  $scope.switchNavItem('latest')
  console.log $scope.discussions


app.controller "DiscussionCtrl", ($scope, $state, $stateParams, $window, $mdDialog, discussion, Users, DiscussionFactory, CurrentUser, DiscussionCategories, CLOUDINARY_CONFIGS) -> #
  $scope.discussion = discussion
  $scope.categories = DiscussionCategories
  $scope.Users = Users
  $scope.discussion.newComment ={}
  $scope.currentUser = CurrentUser.get()
  $scope.moment = $window.moment
  $scope.IMAGE_BASE_URL = CLOUDINARY_CONFIGS.IMAGE_BASE_URL

  $scope.sendComment = ->
    return unless discussion.newComment.text.length>0
    $scope.discussion.addComment(discussion.newComment).then ->
      $scope.discussion.newComment = {}

  $scope.selectCommentFiles = (files, discussion)->
    $scope.discussion.newComment ||= {}
    comment = $scope.discussion.newComment
    comment.images ||= []
    for file in files
      if comment.images.length >= 2
        return alert '添付できる写真は2枚までです。'
      comment.images.push(file)


  $scope.removeDiscussion = (ev)->
    confirm = $mdDialog.confirm()
      .title('投稿の削除')
      .textContent('この投稿を削除します。よろしいですか？')
      .ariaLabel('removing comment')
      .targetEvent(ev)
      .ok('削除')
      .cancel('キャンセル')
    $mdDialog.show(confirm).then ->
      $scope.discussion.$remove()
      $state.go('dashboard.forum')
    

  $scope.removeComment = (key, ev) ->
    confirm = $mdDialog.confirm()
      .title('コメントの削除')
      .textContent('このコメントを削除します。よろしいですか？')
      .ariaLabel('removing comment')
      .targetEvent(null)
      .ok('削除')
      .cancel('キャンセル')
    $mdDialog.show(confirm).then ->
      console.log key
      $scope.discussion.removeComment(key)

  $scope.openPhotoModal = (id) ->
    $mdDialog.show
      controller: ($scope) -> $scope.id = id
      templateUrl: 'templates/dialogs/image.html'
      parent: angular.element(document.body)
      clickOutsideToClose:true
  


app.controller "GuidelineCtrl", ($scope, $state) ->


app.controller "IntroCtrl", ($scope, $state, $translate) ->
    

    

app.controller "EntriesCtrl", ($scope, $state, $sce, $mdDialog, $location, $stateParams, Books) ->
  stage = if $stateParams.stage then parseInt($stateParams.stage) else 1
  $scope.entries = Books.getByStage(stage)
  $scope.currentPath = $location.path()
  $scope.search = {}
  $scope.search.keyword = ""
  $scope.search.showCompleted = false
  $scope.search.filter = (entry) ->
    keyword = $scope.search.keyword
    return false if !$scope.search.showCompleted and entry.size is entry.progress
    return true if keyword is null or keyword.length < 1
    if match = keyword.match(/^tag:\w?(.+)$/)
      entry.disaster_list?.some (tag) ->
        match[1] == tag.name
    else if match = keyword.match(/^region:\w?(.+)$/)
      entry.region_list?.some (region) ->
        match[1] == region
    else
      new RegExp($scope.search.keyword).test(entry.title)
  $scope.searchByTag = (name) ->
    $scope.search.keyword = "tag:"+name
  $scope.searchByRegion = (name) ->
    $scope.search.keyword = "region:"+name

  $scope.openBookDialog = (book)->
    $mdDialog.show
      controller: 'BookDialogCtrl'
      templateUrl: 'templates/dialogs/book.html'
      parent: angular.element(document.body)
      locals:
        book: book
      clickOutsideToClose: true

app.controller "CreditCtrl", ($scope, $state) ->
  

    

app.controller "NewsCtrl", ($scope, $state, $window) ->


app.controller "EditingListCtrl", ($scope, $window,UserEditing, Books) ->
  $scope.editingList = UserEditing.getList()
  $scope.Books = Books
  $scope.moment = $window.moment

app.controller "SignInCtrl", ($scope, $state, $stateParams, $firebaseAuth, $location, $timeout, $translate, CurrentUser) ->
  $translate.onReady ->
    $scope.lang = $translate.use()
  $scope.switchLang = (lang) ->
    $translate.use(lang).then ->
      $scope.lang = $translate.use()


  updateUserData = (data)->
    user = CurrentUser.get()
    data =
      name: data.displayName
      avatar: data.photoURL?.replace('http:', 'https:')
      providerId: data.providerId
    user.update(data)


  goDashboardOrRedirect = ->
    console.log $stateParams.redirect
    if $stateParams.redirect and $stateParams.redirect.length > 0
      $location.path(decodeURIComponent($stateParams.redirect))
    else
      $timeout ->
        console.log "going home"
        $state.go('dashboard.home')


  $scope.signInWithGoogle = ->
    console.log("google sign in")
    provider = new firebase.auth.GoogleAuthProvider()
    provider.addScope('https://www.googleapis.com/auth/plus.login')
    $firebaseAuth().$signInWithPopup(provider)
      .then (auth) ->
        user = auth.user        
        data =           
          displayName: user.displayName or user.providerData[0].displayName
          photoURL: user.photoURL or user.providerData[0].photoURL
          providerId: "google.com"
        updateUserData(data)
        goDashboardOrRedirect()
      .catch (err) ->
        console.log(err)

  $scope.signInWithFacebook = ->
    $firebaseAuth().$signInWithPopup("facebook")
      .then (auth) ->
        console.log auth
        user = auth.user
        updateUserData(user.providerData[0])
        goDashboardOrRedirect()   
     .catch (err) ->
        console.log(err)
  
  $scope.signInWithTwitter = ->
    $firebaseAuth().$signInWithPopup("twitter")
      .then (auth) ->
        user = auth.user        
        updateUserData(user.providerData[0])
        goDashboardOrRedirect()
      .catch (err) ->
        console.log(err)

app.controller 'QuakesCtrl' , ($scope, $mdDialog, $window, Quakes) ->
  $scope.quakes = Quakes.getList()
  $scope.moment = $window.moment
  console.log $scope.quakes



// WEBPACK FOOTER //
// ./app/controllers/controllers.coffee